import { useEffect } from "react";
import { useLocation } from "wouter";
import { pages, siteUrl } from "@/data/seo";

export default function PageMetadata() {
  const [path] = useLocation();
  useEffect(() => {
    const normalizedPath = path === "/" ? "/" : `${path.replace(/\/+$/, "")}/`;
    const page = pages.find(item => item.path === normalizedPath);
    let robots = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    if (!page) {
      if (!robots) {
        robots = document.createElement("meta");
        robots.name = "robots";
        document.head.appendChild(robots);
      }
      robots.content = "noindex";
    } else {
      robots?.remove();
    }
    document.title = page?.title ?? "Page Not Found | All In Solutions";
    if (!page) return;
    let canonical = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
    if (!canonical) {
      canonical = document.createElement("link");
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = siteUrl + page.path;
    for (const [attribute, key, value] of [
      ["name", "description", page.description],
      ["property", "og:site_name", "All In Solutions"],
      ["property", "og:type", "website"],
      ["property", "og:title", page.title],
      ["property", "og:description", page.description],
      ["property", "og:url", siteUrl + page.path],
      ["property", "og:image", `${siteUrl}/hero.webp`],
      ["name", "twitter:card", "summary_large_image"],
      ["name", "twitter:title", page.title],
      ["name", "twitter:description", page.description],
      ["name", "twitter:image", `${siteUrl}/hero.webp`],
    ]) {
      let meta = document.querySelector<HTMLMetaElement>(`meta[${attribute}="${key}"]`);
      if (!meta) {
        meta = document.createElement("meta");
        meta.setAttribute(attribute, key);
        document.head.appendChild(meta);
      }
      meta.content = value;
    }
  }, [path]);
  return null;
}
